import { useGetDocumentaryDossiersSubtypes } from 'client/api/backend/documentary-dossiers/documentary-dossiers';
import {
  SelectInput,
  SelectInputProps
} from 'client/ui/form/input/SelectInput';
import * as React from 'react';

interface IDossierSubtypeInputProps extends SelectInputProps<any> {
  widgetId: number;
}

export function DossierSubtypeInput(props: IDossierSubtypeInputProps) {
  const { widgetId, ...otherProps } = props;
  const subtypesResult = useGetDocumentaryDossiersSubtypes({
    widgetId: props.widgetId
  });

  return (
    <SelectInput
      allowClear
      showSearch
      loading={subtypesResult.isLoading}
      options={[
        ...(subtypesResult.data?.map(mode => ({
          label: mode.label!,
          value: Number(mode.value!)
        })) ?? [])
      ]}
      {...otherProps}
    />
  );
}
